import styled, { StyledComponentProps } from 'styled-components';
import logo from '../gfx/logo.png';

const Image = styled.img`
  max-width: 100%;
  height: auto;
  user-select: none;
`;

export const Logo = (props: StyledComponentProps<"img", any, {}, never>) => {
  return (
    <Image src={logo} alt="logo" {...props}/>
  )
};
